import React from 'react';
import { List } from 'semantic-ui-react';
import { renderInlineReferences } from '../parseInlineReferences';

const BulletList = ({ block, onReferenceClick }) => (
  <List bulleted={!block.ordered} ordered={!!block.ordered}>
    {block.items.map((item, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <List.Item key={index}>{renderInlineReferences(item, onReferenceClick)}</List.Item>
    ))}
  </List>
);

export default BulletList;
